import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

export default function Impressum() {
    const [kontakte, setKontakte] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("/api/kontakte.php", {
            credentials: "include"
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Kontakte konnten nicht geladen werden");
                }

                return response.json();
            })
            .then((data) => {
                setKontakte(data.contact ?? []);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <p> Wird geladen...</p>;
    }

    return (
        <div style={pageStyle}>
            <div style={panelStyle}>
                <Link to="/" style={backLinkStyle}>← Zurück zum Universum</Link>
                <h1 style={titleStyle}>Impressum</h1>

                <Section title="Angaben gemäß § 5 TMG">
                    {kontakte.map((kontakt, index) => (
                        <div key={index}>
                            <p style={lineStyle}>{kontakt.name}</p>
                            <p style={lineStyle}>{kontakt.strasse}</p>
                            <p style={lineStyle}>{kontakt.plz}</p>
                        </div>
                    ))}
                </Section>

                <Section title="Kontakt">
                    {kontakte.map((kontakt, index) => (
                        <p style={lineStyle}>E-Mail: {kontakt.email}</p>
                    ))}
                </Section>

                <Section title="Zweck der Website & Berufsbezeichnung">
                    <p style={lineStyle}>Diese Website ist ein rein privates, nicht-kommerzielles Online-Portfolio.
                        Es dient ausschließlich der Präsentation studentischer Arbeiten und der Bewerbung für Praktika
                        und Arbeitsverhältnisse. Ich bin Architekturstudent an der Hochschule RheinMain und
                        führe nicht die geschützte Berufsbezeichnung „Architekt“.
                    </p>
                </Section>

                <Section title="Urheberrecht & studentische Arbeiten">
                    <p style={lineStyle}>Die durch mich erstellten Inhalte und Werke (Texte, Fotografien, Pläne,
                        Renderings, Grafiken) auf diesen Seiten unterliegen dem deutschen Urheberrecht.
                        Soweit nicht anders angegeben, handelt es sich bei den gezeigten Projekten um akademische
                        Entwürfe, d
                        ie im Rahmen meines Studiums an der Hochschule RheinMain entstanden sind.
                    </p>
                </Section>

                <p style={lineStyle}>Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                    Verwertung bedürfen meiner schriftlichen Zustimmung. Bei Gruppenarbeiten sind die
                    jeweiligen Miturheber am Projekt explizit gekennzeichnet. Urheberrechte Dritter
                    (z. B. Kartengrundlagen, Aufgabenstellungen der Lehrstühle oder verwendete Texturen)
                    werden beachtet und am jeweiligen Projekt ausgewiesen.
                </p>
            </div>
        </div>
    );
}

export function Section({title, children}) {
    return (
        <section style={{marginBottom: '24px'}}>
            <h2 style={sectionTitleStyle}>{title}</h2>
            {children}
        </section>
    );
}

const pageStyle = {
    height: "90%",
    background: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
    padding: '8vh 24px',
    boxSizing: 'border-box',
    fontFamily: 'system-ui, sans-serif',
    color: '#111',
    overflow: 'auto',
};
const panelStyle = {maxWidth: '640px', width: '100%'};
const titleStyle = {fontSize: '28px', margin: '5px 0 32px'};
const sectionTitleStyle = {fontSize: '16px', fontWeight: 600, margin: '0 0 8px'};
const lineStyle = {margin: '2px 0', color: '#444'};
const backLinkStyle = {display: 'inline-block', marginTop: '32px', color: '#111'};
